/** Known ShipStation tag names from the `shipStationTags` collection (synced by merlin-core). */
import { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from 'config/firebase';
import { useFirebaseAuth } from 'context/FirebaseAuthContext';
import { SHIPSTATION_TAGS_COLLECTION } from '../config/rateShopConstants';

export function useShipStationTags() {
  const [user, authLoading] = useFirebaseAuth();
  const [tags, setTags] = useState([]); // [{ tagId, name, color }]
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading || !user) return;
    let active = true;
    getDocs(collection(db, SHIPSTATION_TAGS_COLLECTION))
      .then(snap => {
        if (!active) return;
        setTags(
          snap.docs
            .map(d => d.data())
            .filter(t => t?.name)
            .sort((a, b) => String(a.name).localeCompare(String(b.name)))
        );
      })
      .catch(err => console.error('shipStationTags fetch failed', err))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [authLoading, user]);

  return { tags, tagNames: tags.map(t => t.name), loading };
}
